'use strict';

import * as dom from '../lib/dom.js';

function scrollToSpecial() {
    const url = (new URL(document.location)).searchParams;
    const param = url.get('especial');

    if(param !== null) {
        const target = document.querySelector('#' + param);

        console.log(target);

        setTimeout(function() {
        
            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: target.getBoundingClientRect().top - 40
            });
        }, 1);
    }

}

export default function(){
    window.addEventListener('turbolinks:load', function() {
        scrollToSpecial();
    })
}
